var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[(this.$route.name !== 'Login')?_c('TopBar'):_vm._e(),(this.$route.name !== 'Login')?_c('SideBar'):_vm._e(),_c('v-main',[_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[_c('router-view')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }